
import { HTTPResponse, SideMenuItems, ToastMessages, ToastMessageType, Values } from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import { AppContext } from "../../Contexts/AppContextProvider";
import React, { useContext, useEffect, useState, useRef } from "react";
import { CommonError_Msgs, fourToFifteen, sixteenToTwentySeven, zeroToThree, zeroToTwelve } from "../../Helpers/HelperText";
import { GetLocalStorageData, GetLoggedInUserID, GetOrdinal, IsAdmin, IsDateAfter, IsDateBefore, applySidebarState, toggleSidebar } from "../../Helpers/Utilities";
import DateControl from "../../Components/DateControl";
import InfoPopUp from "../../Components/InfoPopUp";
import { MMAComplicationsService } from "../../WebApiServices/MMAComplicationsService";
import ErrorField from "../../Components/ErrorField";

const Checkbox = ({ id, name, onChange, checked }) => {
  return (
    <input
      type="checkbox"
      id={id}
      name={name}
      onChange={onChange}
      checked={checked}
    />
  );
};

const RadioBox = ({ id, name, onChange, checked }) => {
  return (
    <input
      type="radio"
      id={id}
      name={name}
      onChange={onChange}
      checked={checked}
    />
  );
};

// Comparison Table Component
// const ComparisonComponent = ({ checkboxId, checkboxName, radioName }) => {
//   return (
//     <td className="containertd">
//       {/* Checkbox */}
//       <div style={{ textAlign: "center" }}>
//         <input type="checkbox" id={checkboxId} name={checkboxName} /> <br />
//       </div>

//       {/* Text */}
//       <span><b>Compared to Period A:</b></span>

//       {/* Radio Buttons */}
//       <div>
//         <label className="option-fbox">
//           <input
//             type="radio"
//             id="improved"
//             name={radioName}
//           />
//           <span>Improved</span>
//         </label>
//       </div>
//       <div>
//         <label className="option-fbox">
//           <input
//             type="radio"
//             id="no-change"
//             name={radioName}
//           />
//           <span>No Change</span>
//         </label>
//       </div>
//       <div>
//         <label className="option-fbox">
//           <input
//             type="radio"
//             id="worsened"
//             name={radioName}
//           />
//           <span>Worsened</span>
//         </label>
//       </div>
//       <div>
//         <label className="option-fbox">
//           <input
//             type="radio"
//             id="unable-to-assess"
//             name={radioName}
//           />
//           <span>Unable to assess</span>
//         </label>
//       </div>
//     </td>
//   );
// };

const MMARelatedComplications = () => {
  const navigatePaths = {
    prevPage: "/OtherLabAssessment",
    currPage: "/MMARelatedComplications",
    nextPage: "/NutritionManagement",
  };

  const pidRef = useRef(0);
  let loggedInUserId = GetLoggedInUserID() ?? 0;

  const [showHide012HyperlinkModal, setShowHide012HyperlinkModal] = useState(false);
  const [showHide03HyperlinkModal, setShowHide03HyperlinkModal] = useState(false);
  const [showHide415HyperlinkModal, setShowHide415HyperlinkModal] = useState(false);
  const [showHide1627HyperlinkModal, setShowHide1627HyperlinkModal] = useState(false);
  const [patientLocked, setpatientLocked] = useState(false);
  const [mmaComplicationsOccurrence, setMmaComplicationsOccurrence] = useState([
    {
      mmacomplicationsoccurrenceid: 0,

      complications: "",

      occurance: "",
      occurance_dt: "",
      occurance_dt_estimated: false,
      occuranceDateUnk: "",

      startDateInvalid: false,
      q56ComplicationEmpty: false,
      q56OccuranceEmpty: false,
      q56OcurranceDateEmpty: false,
      q56OcurranceDateUnkEmpty: false,
    },
  ]);

  const [mmaComplicationData, setMmaComplicationData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});

  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  let dates = GetLocalStorageData("ClinicalCharacteristicsDates") ?? {};

  const { ShowToast, ToggleLoader, HandleSessionTimeout, isSideMenuActive, setisSideMenuActive } = useContext(AppContext);

  const [validationDynamicErrors, setValidationDynamicErrors] = useState({});

  const [showErrors, setShowErrors] = useState(false);
  const [showOnSaveError, setShowOnSaveError] = useState(false);


  // If value is false then don't show column
  let dontShowCol1 = dates?.pretransplant_start_end_criteria === false;
  let dontShowCol2 = dates?.indexdate_threemonth_criteria === false;
  let dontShowCol3 = dates?.post_stabilization_twelvemonth_criteria === false;
  let dontShowCol4 = dates?.twelvemonth_twentyfourmonth_criteria === false;


  useEffect(() => {
    async function FetchData() {
      pidRef.current = GetLocalStorageData("patientId") || 0;
      if (pidRef.current !== 0) {
        ToggleLoader(true);
        await GetMMAComplicationsData();
        ToggleLoader(false);
      }
    }
    FetchData();

  }, [])





  const GetMMAComplicationsData = async () => {
    try {
      const response = await MMAComplicationsService.LoadData(pidRef.current, loggedInUserId);
      if (response?.status === HTTPResponse.OK) {
        const { data } = response;
        setpatientLocked(data.patientLocked);
        if (data.mmaComplicationLoopDetails !== null && data.mmaComplicationLoopDetails.length > 0) {
          let i = 0;
          let dataarray = [];


          for (i; i < data.mmaComplicationLoopDetails.length; i++) {
            const detailsStart = data.mmaComplicationLoopDetails[i];
            const complicationsVisitStart = detailsStart.occurrenceDateUnknown ?? "";

            const startHospitalizationsUnkLTLKT =
              (!dates?.zero_to12months_before_LT_LKT && complicationsVisitStart === Values.value1) ||
                (!dates?.zero_to_3months_after_LT_LKT && complicationsVisitStart === Values.value2) ||
                (!dates?.four_to_15months_after_LT_LKT && complicationsVisitStart === Values.value3) ||
                (!dates?.sixteen_to_27months_after_LT_LKT && complicationsVisitStart === Values.value4)
                ? ""
                : complicationsVisitStart;

            let datacomponent = {
              mmacomplicationsoccurrenceid: data.mmaComplicationLoopDetails[i].mmacomplicationsoccurrenceid !== null
                ? data.mmaComplicationLoopDetails[i].mmacomplicationsoccurrenceid
                : 0,
              complications: data.mmaComplicationLoopDetails[i].complication !== null
                ? data.mmaComplicationLoopDetails[i].complication
                : "",
              occurance: data.mmaComplicationLoopDetails[i].occurrence !== null
                ? data.mmaComplicationLoopDetails[i].occurrence
                : "",
              occurance_dt: data.mmaComplicationLoopDetails[i].occurrenceDate !== null
                ? data.mmaComplicationLoopDetails[i].occurrenceDate
                : "",
              occurance_dt_estimated: data.mmaComplicationLoopDetails[i].occurrenceDateEstimated !== null
                ? data.mmaComplicationLoopDetails[i].occurrenceDateEstimated
                : false,
              occuranceDateUnk: startHospitalizationsUnkLTLKT,

              startDateInvalid: false,
              q56ComplicationEmpty: false,
              q56OccuranceEmpty: false,
              q56OcurranceDateEmpty: false,
              q56OcurranceDateUnkEmpty: false,
            }

            dataarray.push(datacomponent);

          }
          setMmaComplicationsOccurrence(dataarray);
        }

        if (data?.complications?.length > 0) {
          const options = {};
          data.complications.forEach((complication) => {
            options[complication.mmaComplicationTypeId] = {
              Period1: complication.period1,
              Period2: complication.period2,
              Period2_Comparison: complication.period2_Comparison,
              Period3: complication.period3,
              Period3_Comparison: complication.period3_Comparison,
              Period4: complication.period4,
              Period4_Comparison: complication.period4_Comparison,
            };
          });

          setSelectedOptions(options);
        }

        const processedData = data.mmaComplicationTypeDetails.map((item, index, arr) => {
          let type = "checkbox";

          // Check if it's from the "Comorbidities" section
          if (item.section !== "Comorbidities") {
            // Last two rows should have "radio"
            type = index >= arr.length - Values.value2 ? "radio" : "comparison";
          }

          return { ...item, type };
        });

        setMmaComplicationData(processedData);
        setValidationDynamicErrors({});

      } else {
        if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        } else {
          throw response.error;
        }
      }

    }
    catch {

    }
  }

  const Validate = () => {
    let isValid = true;
    let isValidLoop = true;
    let isPageValid = false;
    const errors = {};
    let isAnyOptionSelected = false;
    let q56array = [...mmaComplicationsOccurrence];
    for (let i = 0; i < mmaComplicationsOccurrence.length; i++) {
      if (mmaComplicationsOccurrence[i].complications !== Values.value6) {
        if (mmaComplicationsOccurrence[i].occurance === "" && mmaComplicationsOccurrence[i].occurance_dt === ""
          && mmaComplicationsOccurrence[i].occurance_dt_estimated === false && mmaComplicationsOccurrence[i].occuranceDateUnk === "") {
          q56array[i].q56OccuranceEmpty = true;
          isValid = false;
        }
        if (mmaComplicationsOccurrence[i].complications === "") {
          q56array[i].q56ComplicationEmpty = true;
          isValid = false;
        }

        //isValid = true;
        if (mmaComplicationsOccurrence[i].occurance === Values.value99 && mmaComplicationsOccurrence[i].occuranceDateUnk === "") {
          q56array[i].q56OcurranceDateUnkEmpty = true;
          isValid = false;
        }

        if (mmaComplicationsOccurrence[i].occurance === 1 && mmaComplicationsOccurrence[i].occurance_dt === "") {
          q56array[i].q56OcurranceDateEmpty = true;
          isValid = false;
        }

        const isStartDateBefore = dates.oneYr_pretransplant_start && IsDateBefore(mmaComplicationsOccurrence[i].occurance_dt, dates.oneYr_pretransplant_start);
        const isStartDateAfter = dates.twenty_four_months_post_stabilization && IsDateAfter(mmaComplicationsOccurrence[i].occurance_dt, dates.twenty_four_months_post_stabilization);

        if (isStartDateBefore || isStartDateAfter) {
          q56array[i].startDateInvalid = true;
          isValid = false;
        }
        else {
          q56array[i].startDateInvalid = false;
        }
      }
    }

    setMmaComplicationsOccurrence(q56array);


    // Identify last two rows


    // Track if any period has options selected

    const periodSelectedFlags = {
      Period1: false,
      Period2: false,
      Period3: false,
      Period4: false,
    };

    // Map visible periods
    const visiblePeriods = {
      Period1: !dontShowCol1,
      Period2: !dontShowCol2,
      Period3: !dontShowCol3,
      Period4: !dontShowCol4,
    };

    // Dynamic Controls validation
    mmaComplicationData.forEach((item) => {
      const selectedPeriods = selectedOptions[item.mmacomplicationtypeid] || {};
      const { Period1, Period2, Period3, Period4 } = selectedPeriods;

      // Track selected periods only if visible
      if (visiblePeriods.Period1 && Period1) periodSelectedFlags.Period1 = true;
      if (visiblePeriods.Period2 && Period2) periodSelectedFlags.Period2 = true;
      if (visiblePeriods.Period3 && Period3) periodSelectedFlags.Period3 = true;
      if (visiblePeriods.Period4 && Period4) periodSelectedFlags.Period4 = true;


      if (Period1) {
        if (![Values.value1, Values.value2, Values.value3, Values.value31, Values.value32].includes(item.mmacomplicationtypeid)) {
          ["Period2", "Period3", "Period4"].forEach((period, index) => {
            if (visiblePeriods[period]) {
              const periodChecked = selectedPeriods[period];
              const comparisonKey = `${period}_Comparison`;
              const isRadioSelected = selectedPeriods[comparisonKey];

              // Validate: Both checkbox and radio should be selected
              if (periodChecked && !isRadioSelected) {
                errors[`${item.mmacomplicationtypeid}-${period}`] = CommonError_Msgs.Msg1;
                setShowErrors(true);
                isValidLoop = false;
              }
            }
          });
        }
      }
    });

    // If no options are selected in a period, add a global error for that period
    ["Period1", "Period2", "Period3", "Period4"].forEach((period) => {
      if (visiblePeriods[period] && !periodSelectedFlags[period]) {
        setShowOnSaveError(true);
        errors[period] = CommonError_Msgs.Msg1;
        isValidLoop = false;
      }
    });

    const lastTwoRows = mmaComplicationData.slice(-Values.value2);

    // Identify last two rows and rows above the last two rows
    const rowsAboveLastTwo = mmaComplicationData.slice(0, -Values.value2);

    // Helper function: Check if a period is selected for given rows
    const isPeriodSelectedInRows = (rows, period) =>
      rows.some((item) => selectedOptions[item.mmacomplicationtypeid]?.[period]);

    // Iterate over each period (Period2, Period3, Period4)
    ["Period2", "Period3", "Period4"].forEach((period) => {
      if (!visiblePeriods[period]) return; // Skip hidden periods
      const isSelectedAboveLastTwo = isPeriodSelectedInRows(rowsAboveLastTwo, period);
      const isSelectedInLastTwo = isPeriodSelectedInRows(lastTwoRows, period);

      // If there is a selection above the last two rows but not in the last two rows, it's an error.
      if (!isSelectedAboveLastTwo && !isSelectedInLastTwo) {
        lastTwoRows.forEach((item) => {
          const errorKey = `${item.mmacomplicationtypeid}-${period}`;
          errors[errorKey] = CommonError_Msgs.Msg1;
        });
        isValidLoop = false;
      }
    });

    // Set errors if validation fails
    setValidationDynamicErrors(errors);
    if (isValid && isValidLoop) {
      isPageValid = true;
    }


    return isPageValid;
  }


  const SaveForm = async (validate) => {
      try {
          if (!patientLocked) {
              //Reset Errors
              let isValid = validate ? Validate() : true;
              if (!isValid) {
                  setShowTopErrMsg(true);
                  return false;
              }
              setShowTopErrMsg(false);
              if (pidRef.current > 0) {
                  const data = {
                      MMAComplicationModel: {
                          LoggedInUserId: loggedInUserId,
                          Patientid: pidRef.current,
                          IsValidated: validate,
                          IsAdmin: IsAdmin(),
                          MMAComplicationLoopDetails: [],
                          Complications: generateComplicationsPayload(selectedOptions),
                      },
                  };

                  if (mmaComplicationsOccurrence.length > 0) {
                      for (const hospitalizationVisit of mmaComplicationsOccurrence) {
                          let mmaLoopData = {
                              mmacomplicationsoccurrenceid: hospitalizationVisit.mmacomplicationsoccurrenceid,
                              complication: hospitalizationVisit.complications,
                              occurrence: hospitalizationVisit.occurance,
                              occurrenceDate: hospitalizationVisit.occurance_dt,
                              occurrenceDateEstimated: hospitalizationVisit.occurance_dt_estimated,
                              occurrenceDateUnknown: hospitalizationVisit.occuranceDateUnk,
                          };
                          data.MMAComplicationModel.MMAComplicationLoopDetails.push(mmaLoopData);
                      }
                  }

                  ToggleLoader(true);

                  const response = await MMAComplicationsService.SaveData(data.MMAComplicationModel);
                  ToggleLoader(false);
                  if (response.status !== HTTPResponse.OK) {
                      if (response?.status === HTTPResponse.Unauthorized) {
                          HandleSessionTimeout();
                      } else throw response.error;
                  } else {
                      ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
                      // await LoadData();
                      if (response) {
                          const { data } = response;
                          if (data) {
                              SetFields(data);
                              setShowOnSaveError(false);
                          }
                      }
                  }
              }
          }
      return true;
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  const generateComplicationsPayload = (selectedOptions) => {
    return Object.entries(selectedOptions).map(([id, periods]) => ({
      MMAComplicationTypeId: parseInt(id, 10),
      ...periods,
    }));
  };


  const SetFields = (data) => {
    if (data.mmaComplicationLoopDetails !== null && data.mmaComplicationLoopDetails.length > 0) {
      let i = 0;
      let dataarray = [];
      for (i; i < data.mmaComplicationLoopDetails.length; i++) {
        const detailsStart = data.mmaComplicationLoopDetails[i];
        const hospitalizationVisitStart = detailsStart.occurrenceDateUnknown ?? "";

        const startHospitalizationsUnkLTLKT =
          (!dates?.zero_to12months_before_LT_LKT && hospitalizationVisitStart === Values.value1) ||
            (!dates?.zero_to_3months_after_LT_LKT && hospitalizationVisitStart === Values.value2) ||
            (!dates?.four_to_15months_after_LT_LKT && hospitalizationVisitStart === Values.value3) ||
            (!dates?.sixteen_to_27months_after_LT_LKT && hospitalizationVisitStart === Values.value4)
            ? ""
            : hospitalizationVisitStart;

        let datacomponent = {
          mmacomplicationsoccurrenceid: data.mmaComplicationLoopDetails[i].mmacomplicationsoccurrenceid !== null
            ? data.mmaComplicationLoopDetails[i].mmacomplicationsoccurrenceid
            : 0,
          complications: data.mmaComplicationLoopDetails[i].complication !== null
            ? data.mmaComplicationLoopDetails[i].complication
            : "",
          occurance: data.mmaComplicationLoopDetails[i].occurrence !== null
            ? data.mmaComplicationLoopDetails[i].occurrence
            : "",
          occurance_dt: data.mmaComplicationLoopDetails[i].occurrenceDate !== null
            ? data.mmaComplicationLoopDetails[i].occurrenceDate
            : "",
          occurance_dt_estimated: data.mmaComplicationLoopDetails[i].occurrenceDateEstimated !== null
            ? data.mmaComplicationLoopDetails[i].occurrenceDateEstimated
            : false,
          occuranceDateUnk: startHospitalizationsUnkLTLKT,

          startDateInvalid: false,

          q56ComplicationEmpty: false,
          q56OccuranceEmpty: false,
          q56OcurranceDateEmpty: false,
          q56OcurranceDateUnkEmpty: false,
        }

        dataarray.push(datacomponent);

      }
      setMmaComplicationsOccurrence(dataarray);
      setValidationDynamicErrors({});
    }
  }

  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);



  function addMMAComplicationsDetails(e) {
    setMmaComplicationsOccurrence((prev) => [
      ...prev,
      {
        mmacomplicationsoccurrenceid: 0,

        complications: "",

        occurance: "",
        occurance_dt: "",
        occurance_dt_estimated: false,
        occuranceDateUnk: "",

        startDateInvalid: false,
        q56ComplicationEmpty: false,
        q56OccuranceEmpty: false,
        q56OcurranceDateEmpty: false,
        q56OcurranceDateUnkEmpty: false,
      },
    ]);
  }

  const HandleFieldChange = (e) => {
    const { name, value, type, checked } = e.target;
    const splitNameArray = name.split("-");
    const fieldName = splitNameArray[0];
    const index = parseInt(splitNameArray[1], 10);

    setMmaComplicationsOccurrence((prevDetails) => {
      let updatedDetails = prevDetails.map((item, idx) => {
        if (idx === index) {
          let updatedItem = {
            ...item,
            [fieldName]: type === "checkbox" ? checked : (type === "radio" ? parseInt(value, 10) || 0 : value),
          };

          if (fieldName === "complications") {
            if (parseInt(value, 10) === Values.value6) {
              updatedItem.occurance = "";
              updatedItem.occurance_dt = "";
              updatedItem.occurance_dt_estimated = false;
              updatedItem.occuranceDateUnk = "";
            }
            updatedItem.q56ComplicationEmpty = false;
          }

          if (fieldName === "occurance") {
            // if (parseInt(value, 10) === Values.value1) {
            //   updatedItem.occurance_dt = "";
            //   updatedItem.occurance_dt_estimated = false;
            //   updatedItem.occuranceDateUnk = "";
            //   updatedItem.q56OccuranceEmpty = false;
            //   updatedItem.q56OcurranceDateEmpty = false;
            // } else if (parseInt(value, 10) === Values.value99) {
            //   updatedItem.occurance_dt = "";
            //   updatedItem.occurance_dt_estimated = false;
            //   updatedItem.occuranceDateUnk = "";
            //   updatedItem.q56OccuranceEmpty = false;
            //   updatedItem.q56OcurranceDateEmpty = false;
            // }
            if (parseInt(value, 10) === Values.value1 || parseInt(value, 10) === Values.value99) {
              updatedItem.occurance_dt = "";
              updatedItem.occurance_dt_estimated = false;
              updatedItem.occuranceDateUnk = "";
              updatedItem.q56OccuranceEmpty = false;
              updatedItem.q56OcurranceDateEmpty = false;
            }
          } else if (fieldName === "occurance_dt_estimated") {
            updatedItem.occurance = 1;
            updatedItem.occuranceDateUnk = "";
            updatedItem.q56OccuranceEmpty = false;
          } else if (fieldName === "occuranceDateUnk") {
            updatedItem.occuranceDateUnk = parseInt(value, 10);
            updatedItem.occurance_dt = "";
            updatedItem.occurance_dt_estimated = false;
            updatedItem.occurance = 99;
            updatedItem.q56OccuranceEmpty = false;
            updatedItem.q56OcurranceDateUnkEmpty = false;
            updatedItem.q56OcurranceDateEmpty = false;
          }

          return updatedItem;
        }
        return item;
      });

      if (fieldName === "complications" && parseInt(value, 10) === Values.value6 && updatedDetails.length > 1) {

        updatedDetails = [updatedDetails[0]];
      }

      return updatedDetails;
    });
  };


  const HandleDateChange = (name, date, optionId, index) => {
    let { oneYr_pretransplant_start, twenty_four_months_post_stabilization } = dates;
    const lastIndex = name.lastIndexOf("-");
    const idx = name.slice(lastIndex + 1);
    switch (optionId) {
      case "occurance_dt":
        {
          let Q56Admitarray = [...mmaComplicationsOccurrence];
          Q56Admitarray[idx][optionId] = date;
          Q56Admitarray[idx].occurance = 1;
          Q56Admitarray[idx].occuranceDateUnk = "";
          Q56Admitarray[idx].q56OccuranceEmpty = false;
          Q56Admitarray[idx].q56OcurranceDateEmpty = false;
          Q56Admitarray[idx].q56OcurranceDateUnkEmpty = false;


          const isStartDateBefore = oneYr_pretransplant_start && IsDateBefore(date, oneYr_pretransplant_start);
          const isStartDateAfter = twenty_four_months_post_stabilization && IsDateAfter(date, twenty_four_months_post_stabilization);

          if (isStartDateBefore || isStartDateAfter) {
            Q56Admitarray[idx].startDateInvalid = true;
          }
          else {
            Q56Admitarray[idx].startDateInvalid = false;
          }

          setMmaComplicationsOccurrence(Q56Admitarray);
        }
        break;
      default:
        break;
    }
  };

  function deleteMMAComplicationsDetails(id) {
    const newMmaComplicationsOccurrence = [...mmaComplicationsOccurrence];
    newMmaComplicationsOccurrence.splice(id, 1);
    setMmaComplicationsOccurrence(newMmaComplicationsOccurrence);
  }



  const handleCheckboxChange = (id, period, checked) => {
    setSelectedOptions((prev) => {
      const updatedOptions = { ...prev };

      if (id !== Values.value31 && id !== Values.value32) {
        [Values.value31, Values.value32].forEach((clearId) => {
          if (updatedOptions[clearId]) {
            updatedOptions[clearId] = {
              ...updatedOptions[clearId],
              [period]: false,
            };
          }
        });
      }

      if (period === "Period1" && !checked && id !== Values.value1 && id !== Values.value2 && id !== Values.value3) {
        updatedOptions[id] = {
          ...updatedOptions[id],
          Period1: false,

          Period2_Comparison: 0,
          Period3_Comparison: 0,
          Period4_Comparison: 0,
        };
      } else {
        updatedOptions[id] = {
          ...updatedOptions[id],
          [period]: checked,

        };
      }

      // If Period2, Period3, or Period4 is unchecked, reset their Comparison to 0
      if (!checked && ["Period2", "Period3", "Period4"].includes(period)) {
        updatedOptions[id][`${period}_Comparison`] = 0;
      }

      return updatedOptions;
    });

  };


  const handleRadioChange = (id, period, value) => {
    setSelectedOptions((prev) => {
      // Create a copy of the previous state
      const updatedOptions = { ...prev };
      const periodWithoutComparison = period.replace("_Comparison", "");

      if (id !== Values.value31 && id !== Values.value32) {
        [Values.value31, Values.value32].forEach((clearId) => {
          if (updatedOptions[clearId]) {
            updatedOptions[clearId] = {
              ...updatedOptions[clearId],
              [periodWithoutComparison]: false,

            };
          }
        });
      }

      updatedOptions[id] = {
        ...updatedOptions[id],
        [period]: value,
        [period.replace("_Comparison", "")]: true,
        ...(periodWithoutComparison !== "Period1"),
      };

      return updatedOptions;
    });
  };

  const handleRadioLastTwoRbtChange = (id, value) => {
    setSelectedOptions((prev) => {
      const periodToClear = `Period${value}`;

      const updatedOptions = Object.keys(prev).reduce((acc, key) => {
        acc[key] = {
          ...prev[key],
          [periodToClear]: false,
          [`${periodToClear}_Comparison`]: 0
        };

        // If value is 1, clear all Period B to D
        // if (value === 1) {
        //   ["Period2", "Period3", "Period4"].forEach((period) => {
        //     acc[key][period] = false;
        //     acc[key][`${period}_Comparison`] = 0;
        //   });
        // }

        // If value is 1 (Period1), clear Period B to D for all rows except the last two (31, 32)
        if (value === 1 && ![Values.value31, Values.value32].includes(parseInt(key, 10))) {
          ["Period2", "Period3", "Period4"].forEach((period) => {
            //acc[key][period] = false;
            acc[key][`${period}_Comparison`] = 0;
          });
        }

        return acc;
      }, {});

      updatedOptions[id] = {
        ...updatedOptions[id],
        [periodToClear]: true,
      };

      return updatedOptions;
    });
  };

  const periodVisibility = [!dontShowCol1, !dontShowCol2, !dontShowCol3, !dontShowCol4];

  // Check if any option is missing for each visible period across all rows
  const periodErrors = [Values.value1, Values.value2, Values.value3, Values.value4].reduce((acc, periodIdx) => {
    // Skip validation if the period is hidden
    if (!periodVisibility[periodIdx - 1]) return acc;

    const isPeriodEmpty = !mmaComplicationData.some((item) => {
      return selectedOptions[item.mmacomplicationtypeid]?.[`Period${periodIdx}`];
    });

    if (isPeriodEmpty && showOnSaveError) {
      acc[`Period${periodIdx}`] = CommonError_Msgs.Msg1;
    }


    return acc;
  }, {});

  const sectionRowCounts = mmaComplicationData.reduce((acc, item) => {
    acc[item.section] = (acc[item.section] || 0) + 1;
    return acc;
  }, {});

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SaveForm} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div >
          <SideBarMenu activePageId={SideMenuItems.MmsComplications} />
          <>
            <button className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() => toggleSidebar(isSideMenuActive, setisSideMenuActive)}
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                <h4>MMA-RELATED COMPLICATIONS</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              <div className="survey-question-section" >
                <div className="survey-question-content survey-content-box grey-bg">
                  <div className="question-answer">

                    <div className="block-margin white-bg" style={{ marginBlock: "20px 0" }}>
                      <table
                        cellPadding="0"
                        cellSpacing="0"
                        width="100%"
                        border="1"
                        className="borderTable"
                        style={patientLocked ? { pointerEvents: 'none'} : {}}
                        >

                        {/* Q40/56. */}
                        <tr>
                          <td className="containertd">
                            <span>
                              <b>Q56.</b>  Please list <u>all MMA-related complication occurrences</u> that occurred within 12 months prior to and 27 months after the index date (from{" "}
                              <span className="indigo-text">
                                {dates.oneYr_pretransplant_start !== null ? dates.oneYr_pretransplant_start : "[1-year pre-transplant start]"}
                              </span>
                              {" "}to{" "}
                              <span className="indigo-text">
                                {dates.twenty_four_months_post_stabilization !== null ? dates.twenty_four_months_post_stabilization : " [24-month post-stabilization date]"}
                              </span>). Add additional rows for each occurrence of each complication, as needed.
                            </span>
                            <br></br><br></br>
                            <b>Note:</b> <u>all complications must have occurred outside of any MDEs</u> (not during the acute care inpatient, ICU/NICU, ER, or outpatient visit start and end dates of an MDE).
                          </td>
                        </tr>

                        <tr>
                          <td style={{ padding: "6px" }}>
                            {
                              mmaComplicationsOccurrence.length > 0 ? (mmaComplicationsOccurrence.map((data, idx) => (
                                <div className="loop-section-ul" key={data.mmacomplicationsoccurrenceid} >
                                  <div className="loop-head">
                                    <span className="question-weight">
                                      {GetOrdinal(idx + 1)} Complication
                                    </span>
                                    {idx !== 0 && (
                                      <div className="delete-btn-div">
                                        <img
                                          width="16px"
                                          src="../Assets/images/Icon-material-delete.png"
                                          alt=""
                                          onClick={() =>
                                            deleteMMAComplicationsDetails(idx)
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <div className="containertd grid-overflow">
                                    <table
                                      style={patientLocked ? { pointerEvents: 'none',width: "100%",tableLayout: "fixed"} : {width: "100%",tableLayout: "fixed"}}
                                      className="borderTable">
                                      <thead>
                                        <tr>
                                          <th
                                            className="modal-popup-table-header-cell"
                                            style={{ textAlign: "center", width: "49%" }}
                                          >
                                            Complication
                                          </th>
                                          <th
                                            className="modal-popup-table-header-cell"
                                            style={{ textAlign: "center", width: "49%" }}
                                          >
                                            Date of occurrence
                                          </th>
                                          {/* {mmaComplicationsOccurrence.length > 1 ?
                                          <th
                                            className="modal-popup-table-header-cell"
                                            style={{ textAlign: "center", width: "2%" }}
                                          >
                                          </th> : null} */}
                                        </tr>
                                      </thead>

                                      <tbody style={{ border: "1px solid #808080" }}>
                                        <tr>
                                          {/* 1 */}
                                          <td className="containertd" style={{ verticalAlign: "top" }}>
                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"complications-" + idx}
                                                  value={1}
                                                  checked={data.complications === Values.value1}
                                                  onChange={HandleFieldChange}
                                                />
                                                <span className="">
                                                  Nausea or vomiting episode
                                                </span>
                                              </label>
                                            </div>

                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"complications-" + idx}
                                                  value={2}
                                                  checked={data.complications === Values.value2}
                                                  onChange={HandleFieldChange}
                                                />
                                                <span className="">
                                                  Posterior reversible encephalopathy syndrome (PRES)
                                                </span>
                                              </label>
                                            </div>

                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"complications-" + idx}
                                                  value={3}
                                                  checked={data.complications === Values.value3}
                                                  onChange={HandleFieldChange}
                                                />
                                                <span className="">
                                                  Metabolic stroke
                                                </span>
                                              </label>
                                            </div>

                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"complications-" + idx}
                                                  value={4}
                                                  checked={data.complications === Values.value4}
                                                  onChange={HandleFieldChange}
                                                />
                                                <span className="">
                                                  Seizure
                                                </span>
                                              </label>
                                            </div>

                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={"complications-" + idx}
                                                  value={5}
                                                  checked={data.complications === Values.value5}
                                                  onChange={HandleFieldChange}
                                                />
                                                <span className="">
                                                  Encephalopathy
                                                </span>
                                              </label>
                                            </div>
                                            {idx === 0 &&
                                              <div>
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={"complications-" + idx}
                                                    value={6}
                                                    checked={data.complications === Values.value6}
                                                    onChange={HandleFieldChange}
                                                  />
                                                  <span className="">
                                                    None of the above
                                                  </span>
                                                </label>
                                              </div>}

                                            <ErrorField
                                              show={data.q56ComplicationEmpty}
                                              message={CommonError_Msgs.Msg1}
                                            />
                                          </td>
                                          {/* 2 */}
                                          {data.complications === Values.value6 ? (
                                            <td
                                              className="containertd"
                                              style={{
                                                textAlign: "center",
                                                borderRight: "0",
                                              }}
                                            >
                                              <span
                                                style={{ textAlign: "center" }}
                                                className="not-applicable"
                                              >
                                                <b>Not Applicable</b>
                                              </span>
                                            </td>
                                          ) : (
                                            <td
                                              className="containertd"
                                              style={{
                                                borderBottom: "0",
                                              }}
                                            >
                                              <>
                                                <div>
                                                  <label>
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={"occurance-" + idx}
                                                      value={1}
                                                      checked={data.occurance === Values.value1}
                                                      onChange={HandleFieldChange}
                                                    />
                                                    <span className="date-field-padding-left">
                                                      <DateControl
                                                        optionId={"occurance_dt"}
                                                        ctrlId={"occurance_dt-" + idx}
                                                        HandleDateChange={HandleDateChange}
                                                        date={data.occurance_dt} />
                                                    </span>
                                                  </label>
                                                </div>
                                                <div className="estimated-date-padding text-margin">
                                                  <label>
                                                    <input
                                                      type="checkbox"
                                                      id={idx}
                                                      name={"occurance_dt_estimated-" + idx}
                                                      checked={data.occurance_dt_estimated}
                                                      onChange={HandleFieldChange}
                                                    />
                                                    <span className="radio-text-padding">
                                                      Estimated Date
                                                    </span>
                                                  </label>
                                                </div>

                                                <div className="date-field-padding">
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={"occurance-" + idx}
                                                      value={99}
                                                      checked={data.occurance === Values.value99}
                                                      onChange={HandleFieldChange}
                                                    />
                                                    <span className="">
                                                      Date unknown
                                                    </span>
                                                  </label>
                                                  <div style={{ marginLeft: "30px" }}>
                                                    {dates.zero_to12months_before_LT_LKT !== null && dates.zero_to12months_before_LT_LKT &&
                                                      <div>
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={"occuranceDateUnk-" + idx}
                                                            value={1}
                                                            checked={data.occuranceDateUnk === Values.value1}
                                                            onChange={HandleFieldChange}
                                                          />
                                                          <span
                                                            data-tooltip-id="encounterTip"
                                                            className="modal-popup"
                                                            onClick={() =>
                                                              setShowHide012HyperlinkModal(true)
                                                            }
                                                          >
                                                            0 to 12 months before LT/LKT
                                                          </span>
                                                        </label>
                                                      </div>}
                                                    {dates.zero_to_3months_after_LT_LKT !== null && dates.zero_to_3months_after_LT_LKT &&
                                                      <div>
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={"occuranceDateUnk-" + idx}
                                                            value={2}
                                                            checked={data.occuranceDateUnk === Values.value2}
                                                            onChange={HandleFieldChange}
                                                          />
                                                          <span
                                                            data-tooltip-id="encounterTip"
                                                            className="modal-popup"
                                                            onClick={() =>
                                                              setShowHide03HyperlinkModal(true)
                                                            }
                                                          >
                                                            0 to 3 months after LT/LKT
                                                          </span>

                                                        </label>
                                                      </div>}
                                                    {dates.four_to_15months_after_LT_LKT !== null && dates.four_to_15months_after_LT_LKT &&
                                                      <div>
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={"occuranceDateUnk-" + idx}
                                                            value={3}
                                                            checked={data.occuranceDateUnk === Values.value3}
                                                            onChange={HandleFieldChange}
                                                          />
                                                          <span
                                                            data-tooltip-id="encounterTip"
                                                            className="modal-popup"
                                                            onClick={() =>
                                                              setShowHide415HyperlinkModal(true)
                                                            }
                                                          >
                                                            4 to 15 months after LT/LKT
                                                          </span>
                                                        </label>
                                                      </div>}
                                                    {dates.sixteen_to_27months_after_LT_LKT !== null && dates.sixteen_to_27months_after_LT_LKT &&
                                                      <div>
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={idx}
                                                            name={"occuranceDateUnk-" + idx}
                                                            value={4}
                                                            checked={data.occuranceDateUnk === Values.value4}
                                                            onChange={HandleFieldChange}
                                                          />
                                                          <span
                                                            data-tooltip-id="encounterTip"
                                                            className="modal-popup"
                                                            onClick={() =>
                                                              setShowHide1627HyperlinkModal(true)
                                                            }
                                                          >
                                                            16 to 27 months after LT/LKT
                                                          </span>
                                                        </label>
                                                      </div>}
                                                    <div>
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={idx}
                                                          name={"occuranceDateUnk-" + idx}
                                                          value={5}
                                                          checked={data.occuranceDateUnk === Values.value5}
                                                          onChange={HandleFieldChange}
                                                        />
                                                        <span className="">
                                                          Date completely unknown
                                                        </span>
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                              <ErrorField
                                                show={data.startDateInvalid}
                                                message={CommonError_Msgs.Msg2}
                                              />

                                              <ErrorField
                                                show={data.q56OccuranceEmpty}
                                                message={CommonError_Msgs.Msg1}
                                              />

                                              <ErrorField
                                                show={data.q56OcurranceDateEmpty}
                                                message={CommonError_Msgs.Msg2}
                                              />

                                              <ErrorField
                                                show={data.q56OcurranceDateUnkEmpty}
                                                message={CommonError_Msgs.Msg1}
                                              />
                                            </td>)}
                                          {/* {idx > 0 &&
                                          <td>
                                            <div className="loop-head" style={{ padding: "2px" }}>
                                              <div className="delete-btn-div    ">
                                                <img
                                                  width="16px"
                                                  src="../Assets/images/Icon-material-delete.png"
                                                  alt=""
                                                  onClick={(e) => deleteMMAComplicationsDetails(idx)}
                                                />
                                              </div>
                                            </div>
                                          </td>} */}
                                        </tr>
                                      </tbody>

                                    </table>
                                  </div>
                                </div>))) : (<></>)
                            }
                            {
                              mmaComplicationsOccurrence && mmaComplicationsOccurrence[0].complications !== Values.value6 && patientLocked===false &&
                              // <div>
                              <div className="answer-list-text" onClick={addMMAComplicationsDetails} style={{ width: "fit-content" }}>
                                <a>
                                  <img width="18px" src="../Assets/images/plus.png" alt="" />
                                </a>
                                <a className="radio-text-padding">
                                  Click here to add another complication
                                </a>
                                {/* </div> */}
                              </div>}
                          </td>
                        </tr>

                      </table>
                    </div>
                    {/* Q41/57. */}
                    <div className="block-margin white-bg" style={{ marginBlock: "20px 0" }}>
                      <table
                        cellPadding="0"
                        cellSpacing="0"
                        border="1"
                        width="100%">

                        <tr>
                          <td className="containertd">
                            <span>
                              <b>Q57.</b>  Please report which, if any, of the following <u>other complications or comorbidities</u> were reported within the target periods defined below. Excluding comorbidities, please indicate whether the complication has improved, remained the same, or worsened in Periods B, C or D relative to Period A, if this information is available. <i>Select all that apply.</i>
                              <br />
                              <br />
                              <b>Note:</b> <u>all complications must have occurred outside of any MDEs</u> (not during the acute care inpatient, ICU/NICU, ER, or outpatient visit start and end dates of an MDE).

                            </span>
                          </td>
                        </tr>

                        <tr>
                          <td style={{ padding: 0 }}>
                            <div style={{ maxHeight: "500px", overflowY: "auto", border: "1px solid #ccc" }}>
                              <table
                                className="borderTable"
                                border="1"
                                style={patientLocked ? { pointerEvents: 'none', width: '100%',tableLayout: "fixed", borderCollapse: "collapse"} : {width: '100%',tableLayout: "fixed", borderCollapse: "collapse"}}
                              >
                                <thead style={{
                                  position: "sticky",
                                  top: 0,
                                  //zIndex: 10,
                                  background: "#fff",
                                  //borderBottom: "2px solid #000",
                                }}>
                                  <tr className="custom-position-rel" >

                                    <th
                                      style={{ padding: "8px", textAlign: "center" }}
                                    >
                                      <div className="floating-border-bottom"></div>
                                      Target periods
                                    </th>
                                    <th
                                      className="custom-position-rel"
                                      style={{ padding: "8px", textAlign: "center", verticalAlign: "top" }}
                                    >
                                      <div className="floating-border-left-first"></div>
                                      <b>Period A</b>
                                      <br />
                                      From (<span className="indigo-text">{dates?.oneYr_pretransplant_start !== null ? dates?.oneYr_pretransplant_start : "[1-year pre-transplant start] "}</span> to <span className="indigo-text">{dates?.oneYr_pretransplant_end !== null ? dates?.oneYr_pretransplant_end : "[1-year pre-transplant end]"}</span>)
                                    </th>
                                    <th

                                      className="custom-position-rel"
                                      style={{ padding: "8px", textAlign: "center", verticalAlign: "top" }}
                                    >
                                      <div className="floating-border-left"></div>
                                      <b>Period B</b>
                                      <br />
                                      From (<span className="indigo-text">{dates?.indexDt !== null ? dates?.indexDt : "[index date]"}</span> to <span className="indigo-text">{dates?.three_month_stabilization !== null ? dates?.three_month_stabilization : "[3-month stabilization date]"}</span>)
                                    </th>
                                    <th
                                      className="custom-position-rel"
                                      style={{ padding: "8px", textAlign: "center", verticalAlign: "top" }}
                                    >
                                      <div className="floating-border-left"></div>
                                      <b>Period C</b>
                                      <br />
                                      From (<span className="indigo-text">{dates?.post_stabilization_start !== null ? dates?.post_stabilization_start : "[Post-stabilization start date]"}</span> to <span className="indigo-text">{dates?.twelve_month_post_stabilization !== null ? dates?.twelve_month_post_stabilization : "[12-month post-stabilization date]"}</span>)
                                    </th>
                                    <th
                                      className="custom-position-rel"
                                      style={{ padding: "8px", textAlign: "center", verticalAlign: "top" }}
                                    >
                                      <div className="floating-border-left"></div>
                                      <b>Period D</b>
                                      <br />
                                      From (<span className="indigo-text">
                                        {
                                          dates?.twelve_month_post_stabilization_plusOneday ? dates?.twelve_month_post_stabilization_plusOneday : "[12-month post-stabilization date + 1 day] "
                                        }
                                      </span>
                                      {" "}
                                      to <span className="indigo-text">{dates?.twenty_four_months_post_stabilization !== null ? dates?.twenty_four_months_post_stabilization : "[24-month post-stabilization date]"}</span>)
                                    </th>
                                  </tr>
                                </thead>
                                <tbody style={{ border: "1px solid #808080" }}>


                                  {mmaComplicationData.reduce((acc, item, index, arr) => {
                                    const isNewSection = index === 0 || item.section !== arr[index - 1].section;

                                    // Count rows in each section
                                    if (isNewSection) {
                                      acc.sectionRowCount = 0;
                                    }
                                    acc.sectionRowCount++;


                                    // Handle section rows
                                    if (isNewSection) {
                                      acc.push(
                                        <tr key={`section-${item.section}`}>
                                          <td style={{ paddingLeft: 12, backgroundColor: "#adadad" }} colSpan={5}>
                                            <span><i>{item.section}</i></span>
                                          </td>
                                        </tr>
                                      );
                                    }

                                    let emptyCell = (
                                      <td
                                        className="modal-popup-table-cell parent-custom-bottom-border-disabled"
                                        rowSpan={isNewSection ? sectionRowCounts[item.section] : undefined}
                                      >
                                        <div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                          Not Applicable
                                        </div>
                                      </td>
                                    );

                                    //let emptyCell = <td className="modal-popup-table-cell parent-custom-bottom-border-disabled"><div className="custom-date-field-padding" style={{ textAlign: 'center', fontWeight: 'bold' }}>Not Applicable</div> </td>;

                                    acc.push(
                                      <tr key={item.mmacomplicationtypeid}>
                                        {/* First column (Item Name) */}
                                        <td className="containertd">
                                          <span>{item.name}</span>
                                        </td>

                                        {/* Comorbidities Section - Checkbox only */}
                                        {item.section === "Comorbidities" ? (
                                          [dontShowCol1, dontShowCol2, dontShowCol3, dontShowCol4].map((isHidden, idx) =>
                                            !isHidden ? (
                                              <td key={`${item.mmacomplicationtypeid}-checkbox-${idx}`} style={{ textAlign: "center" }}>
                                                <Checkbox
                                                  id={`${item.mmacomplicationtypeid}-${idx}`}
                                                  name={item.name}
                                                  checked={selectedOptions[item.mmacomplicationtypeid]?.[`Period${idx + 1}`] || false}
                                                  onChange={(e) =>
                                                    handleCheckboxChange(item.mmacomplicationtypeid, `Period${idx + 1}`, e.target.checked)
                                                  }
                                                />
                                              </td>
                                            ) : index === arr.findIndex((el) => el.section === item.section) ? emptyCell : null
                                          )
                                        ) : index >= arr.length - Values.value2 ? (
                                          // Last 2 Rows - Radio Buttons Only
                                          [dontShowCol1, dontShowCol2, dontShowCol3, dontShowCol4].map((isHidden, colIndex) =>
                                            !isHidden ? (
                                              <td key={`${item.mmacomplicationtypeid}-radio-${colIndex}`} style={{ textAlign: "center" }}>
                                                <RadioBox
                                                  id={`${item.mmacomplicationtypeid}-radio-${colIndex}`}
                                                  name={`Period-${colIndex + 1}`}
                                                  checked={selectedOptions[item.mmacomplicationtypeid]?.[`Period${colIndex + 1}`] || false}
                                                  onChange={() => handleRadioLastTwoRbtChange(item.mmacomplicationtypeid, colIndex + 1)}
                                                />
                                              </td>
                                            ) :
                                              index === arr.findIndex((el) => el.section === item.section) ? emptyCell : null
                                          )
                                        ) : (
                                          // Other Rows - Checkbox + Radio Buttons
                                          <>
                                            {/* Period 1 - Checkbox */}
                                            {!dontShowCol1 ? (
                                              <td style={{ textAlign: "center" }}>
                                                <Checkbox
                                                  id={item.mmacomplicationtypeid}
                                                  name={item.name}
                                                  checked={selectedOptions[item.mmacomplicationtypeid]?.Period1 || false}
                                                  onChange={(e) =>
                                                    handleCheckboxChange(item.mmacomplicationtypeid, "Period1", e.target.checked)
                                                  }
                                                />
                                              </td>
                                            ) : index === arr.findIndex((el) => el.section === item.section) ? emptyCell : null}

                                            {/* Periods 2, 3, 4 - Checkbox + Radio Buttons */}
                                            {[dontShowCol2, dontShowCol3, dontShowCol4].map((isHidden, colIndex) => {
                                              if (isHidden) return index === arr.findIndex((el) => el.section === item.section) ? emptyCell : null; // Skip hidden columns

                                              const periodKey = `Period${colIndex + Values.value2}`;
                                              const comparisonKey = `${periodKey}_Comparison`;
                                              const isPeriod1Checked = selectedOptions[item.mmacomplicationtypeid]?.Period1;
                                              const isPeriodChecked = selectedOptions[item.mmacomplicationtypeid]?.[periodKey];
                                              const isRadioSelected = selectedOptions[item.mmacomplicationtypeid]?.[comparisonKey];

                                              const errorKey = `${item.mmacomplicationtypeid}-${periodKey}`;
                                              //const showError = isPeriod1Checked && (!isPeriodChecked || !isRadioSelected) && showErrors;
                                              const showError = !isPeriod1Checked || !isPeriodChecked ? false : isPeriod1Checked && isPeriodChecked && !isRadioSelected && showErrors;

                                              return (
                                                <td className="containertd" key={`${item.mmacomplicationtypeid}-comparison-${colIndex}`}>

                                                  <>
                                                    {/* Checkbox for the period */}
                                                    <div style={{ textAlign: "center" }}>
                                                      <Checkbox
                                                        id={`${item.mmacomplicationtypeid}-${colIndex}`}
                                                        name={item.name}
                                                        checked={isPeriodChecked || false}
                                                        onChange={(e) =>
                                                          handleCheckboxChange(item.mmacomplicationtypeid, periodKey, e.target.checked)
                                                        }
                                                      />
                                                    </div>
                                                    {!dontShowCol1 && isPeriod1Checked && isPeriodChecked && !isHidden && (
                                                      <div>
                                                        {/* Comparison Label */}
                                                        <span><b>Compared to Period A:</b></span>

                                                        {/* Radio Buttons */}
                                                        {[
                                                          { label: "Improved", value: 1 },
                                                          { label: "No Change", value: 2 },
                                                          { label: "Worsened", value: 3 },
                                                          { label: "Unable to assess", value: 4 },
                                                        ].map(({ label, value }) => (
                                                          <div key={value}>
                                                            <label className="option-fbox">
                                                              <input
                                                                type="radio"
                                                                name={`${item.mmacomplicationtypeid}-radio-${colIndex}`}
                                                                value={value}
                                                                checked={isRadioSelected === value}
                                                                onChange={() =>
                                                                  handleRadioChange(item.mmacomplicationtypeid, comparisonKey, value)
                                                                }
                                                              />
                                                              <span>{label}</span>
                                                            </label>
                                                          </div>
                                                        ))}
                                                      </div>
                                                    )}
                                                    {validationDynamicErrors[errorKey] && (
                                                      <ErrorField show={showError && !isHidden} message={validationDynamicErrors[errorKey]} />
                                                    )}
                                                  </>
                                                  {/* ) : (
                                                <div style={{ textAlign: "center" }}>
                                                  <b>Not Applicable</b>
                                                </div>
                                                )} */}
                                                </td>
                                              );
                                            })}
                                          </>
                                        )}
                                      </tr>
                                    );

                                    return acc;
                                  }, [])}


                                  {/* Validation Row (Only if errors exist) */}
                                  {Object.keys(periodErrors).length > 0 && showOnSaveError && (
                                    <tr key="validation-errors">
                                      <td></td>
                                      {[Values.value1, Values.value2, Values.value3, Values.value4].map((periodIdx) => (
                                        <td key={`period-error-${periodIdx}`} style={{ textAlign: "center" }}>
                                          {periodErrors[`Period${periodIdx}`] && (
                                            <ErrorField show={true} message={periodErrors[`Period${periodIdx}`]} />
                                            // <div style={{ color: "red", fontSize: "12px" }}>
                                            //   {periodErrors[`Period${periodIdx}`]}
                                            // </div>
                                          )}
                                        </td>
                                      ))}
                                    </tr>
                                  )}




                                  {/* <ErrorField
                                  show={isNoneSelected}
                                  message={CommonError_Msgs.Msg1}
                                /> */}

                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    {/* </td>
                      </tr>
                    </table> */}
                  </div>
                </div>
              </div>

              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SaveForm} />
              </div>
            </div>
          </div>
        </div>
      </section>
      {showHide012HyperlinkModal && (
        <InfoPopUp
          description={zeroToTwelve(dates.oneYr_pretransplant_start, dates.oneYr_pretransplant_end)}
          OkClick={() =>
            setShowHide012HyperlinkModal(false)
          }
        />
      )}
      {showHide03HyperlinkModal && (
        <InfoPopUp
          description={zeroToThree(dates.indexDt, dates.three_month_stabilization)}
          OkClick={() =>
            setShowHide03HyperlinkModal(false)
          }
        />
      )}
      {showHide415HyperlinkModal && (
        <InfoPopUp
          description={fourToFifteen(dates.post_stabilization_start, dates.twelve_month_post_stabilization)}
          OkClick={() =>
            setShowHide415HyperlinkModal(false)
          }
        />
      )}
      {showHide1627HyperlinkModal && (
        <InfoPopUp
          description={sixteenToTwentySeven(dates.twelve_month_post_stabilization_plusOneday, dates.twenty_four_months_post_stabilization)}
          OkClick={() =>
            setShowHide1627HyperlinkModal(false)
          }
        />
      )}
    </>
  );
};

export default MMARelatedComplications;
